export default {
  'customDomains.title': 'Dominios personalizados',
  'customDomains.subtitle': 'Asocia un dominio propio a un recurso de AUTOMY.',
  'customDomains.add': 'Agregar dominio personalizado',
  'customDomains.addShort': 'Agregar dominio',
  'customDomains.add.submitting': 'Conectando dominio...',
  'customDomains.field.hint':
    'Escribe el hostname, por ejemplo portal.tuempresa.com o siteprueba.atmy.in.',
  'customDomains.search': 'Buscar dominio',
  'customDomains.searchEmpty': 'Ningún dominio coincide con la búsqueda.',
  'customDomains.empty.title': 'No hay dominios personalizados',
  'customDomains.empty.description':
    'Conecta un dominio que te pertenezca para acceder a esta empresa.',
  'customDomains.loadError': 'No pudimos cargar los dominios personalizados.',
  'customDomains.loading': 'Cargando dominios...',
  'customDomains.retryLoad': 'Reintentar',
  'customDomains.column.domain': 'Dominio',
  'customDomains.column.usedBy': 'Usado por',
  'customDomains.column.status': 'Estado',
  'customDomains.usedBy.company': 'Empresa',
  'customDomains.usedBy.app': 'App',
  'customDomains.missingCompany': 'No pudimos identificar la empresa de esta sesión.',

  'customDomains.drawer.kicker': 'Dominio personalizado',
  'customDomains.drawer.title': 'Dominio personalizado',
  'customDomains.drawer.intro': 'Usa tu propio dominio para acceder a este recurso.',
  'customDomains.drawer.empty.title': 'No hay un dominio personalizado configurado.',
  'customDomains.drawer.empty.description': 'Conecta un dominio que te pertenezca a {name}.',
  'customDomains.drawer.back': 'Volver',
  'customDomains.drawer.close': 'Cerrar',
  'customDomains.manage': 'Administrar',
  'customDomains.field.domain': 'Dominio',
  'customDomains.field.placeholder': 'clientes.acme.com',
  'customDomains.add.title': 'Conectar dominio',
  'customDomains.add.submit': 'Conectar dominio',
  'customDomains.managed.title': 'Dominio de AUTOMY',
  'customDomains.managed.hint': 'Siempre disponible',
  'customDomains.managed.editSlug': 'Editar slug',
  'customDomains.section.custom': 'Dominio personalizado',

  'customDomains.status.pending': 'Pendiente',
  'customDomains.status.pendingHint': 'El dominio se agregó. La configuración todavía no empieza.',
  'customDomains.status.configureDns': 'Configurar DNS',
  'customDomains.status.configureDnsHint': 'Agrega los registros DNS para continuar.',
  'customDomains.status.provisioning': 'Aprovisionando',
  'customDomains.status.startedHint': 'Configuración iniciada. Todavía no hay lectura del proveedor.',
  'customDomains.status.settingUp': 'Aprovisionando',
  'customDomains.status.settingUpHint': 'AUTOMY está configurando el dominio.',
  'customDomains.status.httpsHint': 'El DNS ya fue aceptado. Configurando HTTPS.',
  'customDomains.status.retryScheduledHint':
    'Hay un reintento automático. También puedes reintentar ahora.',
  'customDomains.status.active': 'Activo',
  'customDomains.status.activeHint': 'Tu dominio personalizado está conectado y listo para usarse.',
  'customDomains.status.connectedHint': 'Conectado. El sitio abre en este hostname si está publicado.',
  'customDomains.status.disabled': 'Deshabilitado',
  'customDomains.status.disabledHint': 'Este dominio está deshabilitado.',
  'customDomains.status.error': 'Error',
  'customDomains.status.connectFailedHint': 'No se pudo conectar el dominio.',
  'customDomains.status.connectFailedSupportHint':
    'No se pudo conectar el dominio. Contacta a soporte.',
  'customDomains.status.actionRequired': 'Error',
  'customDomains.status.actionRequiredHint': 'No se pudo conectar el dominio.',
  'customDomains.status.setupIssue': 'Error',
  'customDomains.status.setupIssueHint': 'No se pudo conectar el dominio. Contacta a soporte.',
  'customDomains.status.removing': 'Eliminando',
  'customDomains.status.removingHint': 'Este dominio se está desconectando.',

  'customDomains.actions.setup': 'Configurar dominio',
  'customDomains.actions.enable': 'Habilitar',
  'customDomains.actions.check': 'Comprobar ahora',
  'customDomains.actions.checking': 'Comprobando...',
  'customDomains.actions.viewDns': 'Configurar DNS',
  'customDomains.actions.retry': 'Reintentar',
  'customDomains.actions.reviewDns': 'Revisar DNS',
  'customDomains.actions.disable': 'Deshabilitar',
  'customDomains.actions.remove': 'Quitar dominio',
  'customDomains.actions.refresh': 'Actualizar verificación DNS',
  'customDomains.actions.contactSupport': 'Contactar a soporte',

  'customDomains.verify.title': 'Esperando verificación',
  'customDomains.dns.title': 'Configura tu DNS',
  'customDomains.dns.ownership': 'Verifica la propiedad',
  'customDomains.dns.connect': 'Conecta tu dominio',
  'customDomains.dns.type': 'Tipo',
  'customDomains.dns.name': 'Nombre',
  'customDomains.dns.value': 'Valor',
  'customDomains.dns.copy': 'Copiar',
  'customDomains.dns.copyAll': 'Copiar todo',
  'customDomains.dns.expires': 'Vence',
  'customDomains.dns.directCname':
    'El CNAME tiene que apuntar directamente al valor indicado. Un CNAME encadenado no funciona.',
  'customDomains.dns.propagation':
    'Los cambios de DNS pueden tardar en propagarse. Puedes cerrar este panel y volver más tarde.',
  'customDomains.dns.waiting': 'Configurando',
  'customDomains.dns.waitingHint':
    'Los datos de verificación todavía no están listos. Puedes cerrar este panel y volver más tarde.',

  'customDomains.confirm.disableTitle': '¿Deshabilitar {hostname}?',
  'customDomains.confirm.disableBody':
    'El dominio dejará de abrir el sitio. Puedes volver a conectarlo.',
  'customDomains.confirm.removeTitle': '¿Quitar {hostname}?',
  'customDomains.confirm.removeBody':
    'Se quitará este dominio. El hostname podrá usarse de nuevo cuando desaparezca de la lista.',

  'customDomains.error.hostnameRequired': 'Ingresa un dominio.',
  'customDomains.error.hostnameInvalid': 'Ingresa un dominio válido.',
  'customDomains.error.hostnameTooLong': 'Este dominio es demasiado largo.',
  'customDomains.error.hostnameReserved': 'Este dominio no está disponible.',
  'customDomains.error.hostnameDuplicate': 'Este dominio ya se está usando en AUTOMY.',
  'customDomains.error.apexNotSupported':
    'Azure Front Door no admite dominios raíz en esta versión.',
  'customDomains.error.targetNotFound': 'No se encontró el destino del dominio personalizado.',
  'customDomains.error.targetCompanyMismatch':
    'El destino de empresa no coincide con la empresa de la sesión.',
  'customDomains.error.companyNotFound': 'La empresa no existe o fue eliminada.',
  'customDomains.error.wildcardNotSupported': 'Los dominios comodín no están soportados.',
  'customDomains.error.targetNotSupported': 'Este recurso todavía no puede usar dominios personalizados.',
  'customDomains.error.targetNotEligible': 'Este recurso no puede usar dominios personalizados.',
  'customDomains.error.providerNotEnabled':
    'El proveedor de dominios personalizados no está habilitado para este dominio.',
  'customDomains.error.destinationNotReady':
    'Los dominios personalizados todavía no están listos para este espacio. Contacta a soporte.',
  'customDomains.error.invalidState': 'Esta acción no está disponible ahora.',
  'customDomains.error.retryNotAllowed': 'Reintentar no está disponible en el estado actual.',
  'customDomains.error.refreshNotAllowed': 'La verificación DNS no se puede actualizar ahora.',
  'customDomains.error.forbidden': 'No tienes permiso para hacer esta acción.',
  'customDomains.error.notFound': 'Este dominio ya no existe.',
  'customDomains.error.generic': 'Esta acción no está disponible ahora.',
};
